import { gql, useMutation } from "@apollo/client";
import { Chart } from "./query.charts";

const DuplicateChartMutation = gql`
  mutation duplicateChart($input: DuplicateChartInput!) {
    duplicateChart(input: $input) {
      newChart {
        id
        title
        updatedAt
        createdAt
      }
    }
  }
`;

export const useDuplicateChartMutation = () =>
  useMutation<
    {
      duplicateChart: {
        newChart: Chart;
      };
    },
    {
      input: {
        chartID: string;
        title: string;
      };
    }
  >(DuplicateChartMutation);
